{
	"cardHeader": "Accede a tus declaraciones",
	"supplierTitle": "¿Eres el proveedor de una declaración evoZero?",
	"supplierDescription": "Gestiona las declaraciones de tus materiales evoZero.",
	"loginButton": "Acceso"
}
